import type { NavigationGuard, RouteLocationRaw } from 'vue-router';
import { credentialApiService } from '../services/credentialApi.service';

const INTRO_ROUTE_NAME = 'api-credentials-intro';
const MAIN_ROUTE_NAME = 'api-credentials';

/**
 * Decide si el usuario debe ver la introducción o la página principal
 * de Credenciales API consultando el listado real de credenciales.
 *
 * - Si existen credenciales: permite el acceso a la página principal y
 *   redirige a ella si intenta entrar a la intro.
 * - Si no existen credenciales: permite el acceso a la intro y redirige
 *   a ella si intenta entrar a la página principal.
 */
export const credentialApiIntroGuard: NavigationGuard = async (
  to
): Promise<true | RouteLocationRaw> => {
  const result = await credentialApiService.getClients();

  return result.fold(
    () => true,
    (success) => {
      const hasClients = success.data.length > 0;

      if (hasClients) {
        if (to.name === INTRO_ROUTE_NAME) {
          return { name: MAIN_ROUTE_NAME };
        }
        return true;
      }

      if (to.name === INTRO_ROUTE_NAME) {
        return true;
      }

      return { name: INTRO_ROUTE_NAME };
    }
  );
};
